export default __webpack_public_path__ + "30f9fc937de6d4ba1ff955bfb72a1b43.svg";